import { WsCalls } from '@/store/services/wsCalls';

// initial state
const state = () => ({
  saldo: 0,
  history: [],
  loadingCarteira: true
})

// getters
const getters = {
  getSaldoCarteira: (state) => {
    return state.saldo;
  },
	getCarteiraHistory: (state) => {
		return state.history;
	},
}

// actions
const actions = {
  async loadCarteira({ commit, rootGetters }, statement) {
    commit('setLoadingCarteira', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'walletBalance', rootGetters['main/getConfig'], null,{ 'statement': statement } ).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          commit('setCarteira', response.data.return.balance);
          commit('setCarteiraHistory', response.data.return.statement != null ? response.data.return.statement : []);
          commit('setLoadingCarteira', false);
          resolve(true);
        } else {
          commit('setCarteira', 0);
          commit('setCarteiraHistory', []);
          commit('setLoadingCarteira', false);
          resolve(false);
        }
      });
    });
	},
}

// mutations
const mutations = {
	setCarteira(state, saldo){
		state.saldo = saldo;
	},
	setCarteiraHistory(state, history){
		state.history = history;
	},
	setLoadingCarteira(state, status){
		state.loadingCarteira = status;
	},
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}